
import commercialHierarchy from '@/mixins/commercialHierarchy'
import startSellToCommercialHierarchy from './startSellToCommercialHierarchy'
import { Flavors } from '../../plugins/constants'
export default {

  mixins: [commercialHierarchy, startSellToCommercialHierarchy],
  methods: {
    verificarSePodeProsseguirVenda () {
      if (!this.validacoes()) {
        this.$router.replace({ name: 'minhas-vendas' })
      }
    },
    validacoes () {
      if (!this.validacoesHierarquia()) {
        return false
      }
      return true
    },
    validacoesHierarquia () {
      if (!this.is_usuario_logado_hierarquia) {
        return true
      }
      const flavor = this.$session.get('flavor')
      if (flavor === Flavors.ED) {
        return false
      }
      if (this.validarEstruturaEntrandoVenda() && this.validarPontoVendaEntrandoVenda() && this.validarComissionadoEntrandoVenda()) {
        return true
      }
      return false
    }
  }
}
